import { Button, Slide, Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IMAGES_PATH } from 'themes'

const serverErrorImage = IMAGES_PATH('/errors/serverError.svg')
const connectionErrorImage = IMAGES_PATH('/errors/serverOffline.svg')

const styles = makeStyles<Theme>(theme => ({
    toastContainer: {
        backgroundColor: '#FFF',
        position: 'fixed',
        left: 0,
        bottom: 0,
        maxWidth: 500,
        margin: 20,
        padding: 25,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 4,
        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 36px 16px',
        zIndex: 999999,

        [theme.breakpoints.down('sm')]: {
            left: 15,
            right: 15,
            margin: 15,
            padding: 20,
        },
    },
    errorImg: {
        width: 150,
        height: 'auto',

        [theme.breakpoints.down('sm')]: {
            width: 120,
        },
    },
    informationContainer: {
        display: 'flex',
        gap: 20,
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    errorTitle: {
        marginBottom: 5,
        fontSize: 16,
        fontWeight: 600,
    },
    errorMessage: {
        fontSize: 14,

        [theme.breakpoints.up('sm')]: {
            marginBottom: 10,
        },
    },
    closeButton: {
        marginTop: 10,
        fontWeight: 600,
        borderColor: '#DDDDDD',
        borderRadius: 46,

        '&.desktop': {
            display: 'none',
            marginTop: 'auto',
        },

        [theme.breakpoints.up('sm')]: {
            '&.desktop': {
                display: 'block',
            },
            '&.mobile': {
                display: 'none',
            },
        },
    },
}))
// eslint-disable-next-line @typescript-eslint/no-empty-function
let toggleModal = (showVal: boolean, title?: string) => {}

function ErrorToast() {
    const style = styles()
    const { t } = useTranslation()

    const toastClosingTimer = useRef<ReturnType<typeof setTimeout>>()
    const [show, setShow] = useState({ showVal: false, title: '' })

    toggleModal = (showVal: boolean, title?: string) => setShow({ showVal, title })

    useEffect(() => {
        if (show.showVal) toastClosingTimer.current = setTimeout(handleClose, 8000)

        return () => {
            clearInterval(toastClosingTimer.current)
        }
    }, [show])

    const handleClose = () => {
        setShow({ ...show, showVal: false })
        clearInterval(toastClosingTimer.current)
    }

    const toastInformation = {
        serverError: {
            header: t('ErrorBoundary.ErrorServerToast.ServerError'),
            description: t('ErrorBoundary.ErrorServerToast.ServerErrorMessage'),
            img: serverErrorImage,
        },
        serverMaintenance: {
            header: t('ErrorBoundary.ErrorServerToast.ServerMaintenance'),
            description: t('ErrorBoundary.ErrorServerToast.ServerMaintenanceMessage'),
            img: serverErrorImage,
        },
        connectionError: {
            header: t('ErrorBoundary.ErrorServerToast.ConnectionError'),
            description: t('ErrorBoundary.ErrorServerToast.ConnectionErrorMessage'),
            img: connectionErrorImage,
        },
    }

    return (
        <Slide in={show.showVal} direction="right">
            <div className={style.toastContainer}>
                <div className={style.informationContainer}>
                    <img className={style.errorImg} src={toastInformation[show.title]?.img} alt="maintenance" />
                    <div className={style.textContainer}>
                        <Typography className={style.errorTitle}>{toastInformation[show.title]?.header}</Typography>
                        <Typography className={style.errorMessage}>{toastInformation[show.title]?.description}</Typography>
                        <Button className={clsx(style.closeButton, 'desktop')} fullWidth variant="outlined" color="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </div>
                </div>
                <Button className={clsx(style.closeButton, 'mobile')} fullWidth variant="outlined" color="secondary" onClick={handleClose}>
                    Close
                </Button>
            </div>
        </Slide>
    )
}

export { toggleModal }
export default ErrorToast
